import { Button } from "antd"
import { isEmpty } from "lodash"

export const ContainedButton = ({ buttonName, Icon= null, iconPosition="start", handleOnClick= ()=> {}, customClass = ``  }) => {
    if(isEmpty(buttonName)) return <></>; 
    return(
        <Button type="primary" icon={<Icon />} iconPosition={iconPosition} onClick={handleOnClick} className={`!rounded-md ${customClass}`}>{buttonName}</Button>
    )
}